module.exports = "/img/_/_/_/assets/images/creeper/battle/common//32.jpg?b41d34020c0fce09d18b22c3202e78df";